import angular from 'angular';
import ResourcesModule from '../../resources/resources';
import ServicesModule from '../../services/services';
import template from './segmentRow.jade';
import ConfigsModule from "../../configs/configs";

export class SegmentRowController {
  /* @ngInject */
  constructor($stateParams,
      GamesResource,
      SegmentsResource,
      SegmentPreviewResource,
      SegmentSizePreviewResource,
      $state,
      $filter) {
    this.SegmentsResource = SegmentsResource;
    this.GamesResource = GamesResource;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.truncate = $filter('truncate');
    this.segmentLogic = $filter('segmentLogic');
  }

  showSegmentDesc(segment) {
    const segmentDesc = this.segmentLogic(segment)
    return segmentDesc.length <= 100 || segment.showMore ? segmentDesc : this.truncate(segmentDesc, 97, '...')
  }

  onEditSegment() {
    _.without((this.segments||[]), this.segment).forEach(segment => segment.editing = false);
    this.segment.editing = !this.segment.editing;
  }

  shouldShowSegment() {
    const segmentDesc = this.segmentLogic(this.segment)
    return (this.segment.length > 100 || segmentDesc.length > 100);
  }
}

export function SegmentRowComponent(){
  return{
    restrict: 'E',
    template,
    controller: SegmentRowController,
    controllerAs: 'vm',
    scope: {},
    bindToController: {
      segment: '=',
      segments: '=',
      onClonedClicked: '&'
    },
  };
}

export default angular.module('app.components.segmentRow.index', [
  ResourcesModule.name,
  ConfigsModule.name,
  ServicesModule.name
])
.directive('segmentRow', SegmentRowComponent);



/** WEBPACK FOOTER **
 ** ./src/components/segments/segmentRow.js
 **/